import React from 'react';

const DropdownArrow = () => <div aria-hidden="true" className="dropDownArrow"></div>;

export default DropdownArrow;
